const common = {
  site_name: 'CSSBuy Spreadsheet',
  site_tagline: 'Melhor CSSBuy Spreadsheet 2026',
  nav_home: 'Início',
  nav_categories: 'Categorias',
  nav_shopping_guide: 'Guia de Compras',
  nav_blog: 'Blog & Guias',
  btn_cssbuy_sheet: 'CSSBuy Sheet',
  btn_buy_now: 'Buy It Now',
  btn_explore: 'Explorar Agora',
  btn_start: 'Começar Agora',
  btn_read_more: 'Ler Mais',
  btn_back_home: 'Voltar ao Início',
  footer_rights: '© 2026 CSSBuy Spreadsheet. Todos os direitos reservados.',
  footer_description: 'O melhor guia CSSBuy Spreadsheet em português. Links atualizados, guias completos e dicas de segurança para suas compras internacionais.',
  footer_newsletter: 'NEWSLETTER',
  footer_newsletter_placeholder: 'Seu melhor email',
  footer_newsletter_cta: 'Inscrever-se',
  footer_newsletter_hint: 'Receba atualizações semanais. Sem spam.',
  footer_links_title: 'LINKS',
  footer_link_spreadsheet: 'CSSBuy Spreadsheet',
  footer_link_shipping: 'Guia de Envio',
  footer_link_faq: 'FAQ',
  footer_social_title: 'SOCIAL',
  main_site_url: 'https://kaspreadsheet.com',
};

export default common;